app.directive('myUploadData', function ($rootScope) {
    return {
        restrict: 'E',
        templateUrl: '../app/modules/templates/uploadData.html',
        link: function (scope, element, attr) {
            scope.serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
            scope.isFileLengthExceed = false;
            //scope.storeTechniques = ['', 'XPS', 'UPS', 'AES', 'UV-VIS'];
            getObjectTechniques();
            scope.defualtFileStatus = 'No file selected.';
            scope.getFileDetails = function (e) {
                scope.files = [];
                var arrFiles = ['xls', 'xlsx', 'txt', 'csv', 'tsv'];
                scope.$apply(function () {
                    // STORE THE FILE OBJECT IN AN ARRAY.
                    var fileInput = $("input[type=file]");
                    for (var i = 0; i < e.files.length; i++) {

                        var arr = e.files[0].name.split('.');
                        if (arrFiles.indexOf(arr[arr.length - 1]) > -1) {
                            if (e.files[i].size > 0) {
                                getUploadStorageCapacity();
                                var fileInKB = (e.files[i].size / devideByKB).toFixed(2);
                                var fileInMB = (e.files[i].size / devideByMegaBytes).toFixed(2);
                                var fileSizeExceeded = false;
                                var maxSize;

                                if (scope.dataManagement.MaximumUploadSize.indexOf('MB') >= 0) {
                                    maxSize = scope.dataManagement.MaximumUploadSize.substr(0, scope.dataManagement.MaximumUploadSize.length - 2)
                                    if (fileInMB > maxSize) {
                                        fileSizeExceeded = true;
                                    }
                                } else if (scope.dataManagement.MaximumUploadSize.indexOf('KB') >= 0) {
                                    maxSize = scope.dataManagement.MaximumUploadSize.substr(0, scope.dataManagement.MaximumUploadSize.length - 2)
                                    if (parseFloat(fileInKB) > parseFloat(maxSize)) {
                                        fileSizeExceeded = true;
                                    }
                                }

                                scope.fileName = e.files[0].name.length >= 21 ? e.files[0].name.substr(0, 21) + '...' : e.files[0].name;

                                if (fileSizeExceeded) {
                                    fileInput.val('').clone(true);

                                    OnFileIsInvalid(scope);

                                    scope.modalMessage = GetMessage.maximumFileUploadSizeExceeded(scope.dataManagement.MaximumUploadSize);
                                    return false;
                                }

                                var usedSize, totalAllocatedSize;
                                if (scope.dataManagement.UsedSize.indexOf('MB') >= 0) {
                                    usedSize = scope.dataManagement.UsedSize.substr(0, scope.dataManagement.UsedSize.length - 2)
                                } else {
                                    usedSize = scope.dataManagement.UsedSize;
                                }

                                if (scope.dataManagement.TotalAllocatedSize.indexOf('MB') >= 0) {
                                    totalAllocatedSize = scope.dataManagement.TotalAllocatedSize.substr(0, scope.dataManagement.TotalAllocatedSize.length - 2)
                                } else {
                                    totalAllocatedSize = scope.dataManagement.TotalAllocatedSize;
                                }

                                if ((parseFloat(fileInMB) + parseFloat(usedSize)) > totalAllocatedSize) {
                                    fileInput.val('').clone(true);

                                    OnFileIsInvalid(scope);

                                    scope.modalMessage = GetMessage.allocatedSizeExceed;
                                    return false;
                                }

                                scope.files.push(e.files[0]);
                                $('#fileStatus').text(scope.fileName);
                                $('#fileStatus').attr('title', e.files[0].name);
                                scope.modalMessage = '';
                                scope.isModalError = false;
                                scope.isModalSuccess = false;
                            } else {
                                fileInput.val('').clone(true);

                                OnFileIsInvalid(scope);

                                scope.modalMessage = GetMessage.fileIsEmpty;
                                return false;
                            }
                        } else {
                            fileInput.val('').clone(true);

                            OnFileIsInvalid(scope);

                            scope.modalMessage = GetMessage.fileAllowedToUpload;
                            return false;
                        }
                    }
                    if (scope.files.length > 0) {
                        if (e.files[0].name.length > 100) {
                            scope.isModalError = true;
                            scope.isModalSuccess = false;
                            scope.modalMessage = GetMessage.fileNameLengthLimitExceed;
                            scope.FileSelected = true;
                            scope.isDisableStep1 = true;
                            scope.isDisableStep3 = true;
                            scope.isFileLengthExceed = true;
                            return false;
                        } else {
                            scope.isFileLengthExceed = false;
                            scope.FileSelected = true;
                            scope.isDisableStep1 = true;
                            scope.isDisableStep3 = false;
                        }
                    } else {
                        scope.isDisableStep1 = false;
                        OnFileIsInvalid(scope);
                        scope.modalMessage = scope.modalMessage == GetMessage.fileNameLengthLimitExceed ? "" : scope.modalMessage;
                    }

                });
            };

            function OnFileIsInvalid(scope) {
                scope.FileSelected = false;
                scope.isModalError = true;
                scope.isModalSuccess = false;
                scope.isDisableStep3 = true;

                $('#fileStatus').text(scope.defualtFileStatus);
                $('#fileStatus').attr('title', scope.defualtFileStatus);
            }

            scope.FileShare = {
                Yes: false,
                No: false
            }

            scope.FileSelected = false;

            scope.dataManagementValues = function () {
                scope.dataManagement = {
                    HostMaterial: "",
                    ChemicalName: "",
                    ReferencedArticle: "",
                    Techinque: "",
                    FirstName: "",
                    LastName: "",
                    Description: "",
                    eSpectraObjectDOI: "",
                    eSpectraObjectCalibration: '',
                    TotalAllocatedSize: '',
                    UsedSize: '',
                    MaximumUploadSize: '',
                    CasRegistryNumber: ''
                }
                scope.dataManagement.FileShare = "private";
                scope.dataManagement.isPublic = 0;
            }

            scope.dataManagementValues();

            scope.checkTechnique = function () {
                if (scope.dataManagement.Techinque != undefined) {
                    scope.isDisableStep2 = false;
                } else {
                    scope.isDisableStep2 = true;
                }
            }

            scope.removeFile = function () {
                scope.FileSelected = false;
                $('#fileStatus').text('No file selected.');
                scope.isDisableStep1 = false;
                scope.isDisableStep3 = true;
                if (scope.modalMessage == GetMessage.fileNameLengthLimitExceed) {
                    scope.isModalError = false;
                    scope.isModalSuccess = false;
                    scope.modalMessage = "";
                }
            }

            scope.validateCesRegistryNumber = function () {
                var casRegistryNumber = scope.dataManagement.CasRegistryNumber;
                var count = 0;

                if (casRegistryNumber != "") {
                    if (casRegistryNumber.indexOf("-") > 0 && casRegistryNumber.lastIndexOf("-") < casRegistryNumber.length - 1) {
                        for (var i = 0; i < casRegistryNumber.length; i++) {
                            if (casRegistryNumber.charAt(i) == "-") {
                                count++;
                            }
                            if (count > 2) {
                                break;
                            }
                        }
                        if (count != 2) {
                            scope.dataManagementUpload.casregistryno.$invalid = true;
                            scope.dataManagementUpload.$valid = false;
                        }
                    } else {
                        scope.dataManagementUpload.casregistryno.$invalid = true;
                        scope.dataManagementUpload.$valid = false;
                    }
                } else {
                    scope.dataManagementUpload.casregistryno.$invalid = false;
                    scope.dataManagementUpload.$valid = true;
                }
            }

            function getUploadStorageCapacity() {
                $.ajax({
                    url: scope.serviceBase + 'api/datamanagement/getUserStorageCapacity',
                    async: false,
                    type: "GET",
                    dataType: "json",
                    data: {}
                }).success(function (data) {
                    scope.dataManagement.TotalAllocatedSize = data.totalAllocatedSize;
                    scope.dataManagement.UsedSize = data.usedSize;
                    scope.dataManagement.MaximumUploadSize = data.maximumUploadSize;
                }).error(function (data, status) {
                    scope.modalMessage = GetMessage.ApiError;
                    scope.isModalError = true;
                    scope.isModalSuccess = false;
                });
            }

            function getObjectTechniques() {
                var objectTechniques = getLocalValue("objectTechniques");
                scope.storeTechniques = [];
                angular.forEach(objectTechniques, function (value, key) {
                    scope.storeTechniques.push(value);
                });

            }
        }
    }
});

app.directive('toggle', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            if (attrs.toggle == "popover") {
                $(element).popover();
            }
        }
    };
});
